import { render, staticRenderFns } from "./VerMovimiento.vue?vue&type=template&id=25bb91fb&scoped=true"
import script from "./VerMovimiento.vue?vue&type=script&lang=js"
export * from "./VerMovimiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bb91fb",
  null
  
)

export default component.exports